import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const WA = "https://wa.me/56936400479?text=Hola%2C%20quiero%20cotizar%20una%20base%20de%20datos";

const links = [
  { id: "servicios", label: "Servicios", testid: TESTIDS.navServices },
  { id: "cumplimiento", label: "Ley 21.719", testid: TESTIDS.navCompliance },
  { id: "porque", label: "Por qué nosotros", testid: TESTIDS.navWhy },
  { id: "faq", label: "FAQ", testid: TESTIDS.navFaq },
  { id: "contacto", label: "Contacto", testid: TESTIDS.navContact },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#040812]/85 backdrop-blur-xl border-b border-[rgba(0,240,255,0.12)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-4 flex items-center justify-between">
        <a
          href="/#inicio"
          data-testid={TESTIDS.navHome}
          className="flex items-center gap-2 group"
        >
          <div className="relative w-9 h-9 rounded-md bg-[#0a1224] border border-[rgba(0,240,255,0.4)] flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(0,240,255,0.45),transparent_70%)]" />
            <span className="font-display font-black text-[#00f0ff] text-sm relative">CDP</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-white text-[15px] tracking-tight">
              Chile<span className="text-[#00f0ff]">Datos</span>Pro
            </div>
            <div className="font-mono text-[10px] text-[#94a3b8] uppercase tracking-[0.2em]">
              B2B · Chile
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.id}
              href={`/#${l.id}`}
              data-testid={l.testid}
              className="text-[13px] font-medium text-[#94a3b8] hover:text-[#00f0ff] transition-colors uppercase tracking-wider"
            >
              {l.label}
            </a>
          ))}
          <Link
            to="/datos-para-ia"
            data-testid="nav-datosia-link"
            className="text-[13px] font-medium text-[#00f0ff] hover:text-white transition-colors uppercase tracking-wider"
          >
            Datos IA
          </Link>
          <Link
            to="/blog/comprar-datos-contactos-empresas-chile"
            data-testid="nav-blog-link"
            className="text-[13px] font-medium text-[#94a3b8] hover:text-[#00f0ff] transition-colors uppercase tracking-wider"
          >
            Blog
          </Link>
        </nav>

        <a
          href={WA}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={TESTIDS.navWhatsappCta}
          className="hidden sm:inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold text-sm px-5 py-2.5 rounded-full transition-all shadow-[0_8px_24px_-8px_rgba(37,211,102,0.6)] hover:shadow-[0_12px_32px_-8px_rgba(37,211,102,0.8)] hover:-translate-y-0.5"
        >
          <MessageCircle size={16} />
          <span>Cotizar</span>
        </a>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-white"
          aria-label="Abrir menú"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[rgba(0,240,255,0.12)] bg-[#040812]/95 backdrop-blur-xl">
          <div className="px-6 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={`/#${l.id}`}
                onClick={() => setOpen(false)}
                className="text-[#94a3b8] hover:text-[#00f0ff] text-sm uppercase tracking-wider font-medium"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/datos-para-ia"
              onClick={() => setOpen(false)}
              data-testid="nav-datosia-link-mobile"
              className="text-[#00f0ff] hover:text-white text-sm uppercase tracking-wider font-medium"
            >
              Datos IA
            </Link>
            <Link
              to="/blog/comprar-datos-contactos-empresas-chile"
              onClick={() => setOpen(false)}
              data-testid="nav-blog-link-mobile"
              className="text-[#94a3b8] hover:text-[#00f0ff] text-sm uppercase tracking-wider font-medium"
            >
              Blog
            </Link>
            <a
              href={WA}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold px-5 py-3 rounded-full mt-2"
            >
              <MessageCircle size={16} /> Cotizar por WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
